<template>
    <div class="form-group">
        <label :for="getId" v-text="getLabel"></label>
        <ckeditor
            :id="getId"
            :name="getId"
            v-model="currentValue"
        >
        </ckeditor>
    </div>

</template>

<script>
    import fieldInfo from './../mixins/fieldInfo';
    import CKEditor from "../../UI/components/CKEditor";

    export default {
        components: {
            CKEditor,
        },
        mixins: [
            fieldInfo,
        ],
        data() {
            return {};
        },
        methods: {},
        created() {
            this.ref = Math.random().toString(36).substr(2, 9);
        },
        mounted() {}
    }
</script>
